import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const getDocumentCalculationFieldsRuleSchema = createSelector(
  getSystem,
  ({ documentCalculationFieldsRuleSchema }) => documentCalculationFieldsRuleSchema,
);
